"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.neverExpected = void 0;
var neverExpected = function (value) {
    throw new Error("Unexpected value : ".concat(value));
};
exports.neverExpected = neverExpected;
